import { DateObject } from '@capsicum/common';

/**
 * @description
 *  check is processStartedAt params is younger than a duration or 15 minutes (default)
 *
 * @param {string} processStartedAt - the date to check if it's still stale
 * @param {string} expirePeriod - the period to add to the processStartedAt to check if it's over.
 * @returns {boolean} processStartedAt is younger than 15 mins
 */
export const isProcessStartedAtStale = (processStartedAt?: string, expirePeriod?: number): boolean => {
	const now = new DateObject();

	// 15 min in Milliseconds is 9000 which is the default duration.
	const shouldBeExpired = new DateObject(processStartedAt).add(expirePeriod ?? 900000, 'milliseconds');

	return now.isBefore(shouldBeExpired);
};
